import { BaseApiService } from './auth/base-api.service';
import { AccountService } from './auth/account.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RequestTypeEnum } from '../utils/enums';

export class FileService extends BaseApiService {
    private get baseUrl(): string {
        return environment.auth.apiUrl;
    }

    constructor(
        public http: HttpClient,
        public accountService: AccountService,
    ) {
        super(http);
    }

    protected async uploadFile<T>(body: any): Promise<T | undefined> {
        const accountInfo = await this.accountService.getAccountInfo();
        if (accountInfo) {
            return await this.post<T>(`${this.baseUrl}/api/v1/users/${accountInfo.id}/files`, body, null, RequestTypeEnum.FileUpload);
        }
    }

    protected async deleteFile<T>(params: any): Promise<T | undefined> {
        const accountInfo = await this.accountService.getAccountInfo();
        if (accountInfo) {
            return await this.delete<T>(
                `${this.baseUrl}/api/v1/users/${accountInfo.id}/files?${this.toQueryParams(params)}`, null, RequestTypeEnum.FileDelete
                );
        }
    }

    protected async downloadFile<T>(params: any): Promise<T | undefined> {
        const accountInfo = await this.accountService.getAccountInfo();
        if (accountInfo) {
            return await this.get<T>(
                `${this.baseUrl}/api/v1/users/${accountInfo.id}/filecontent?${this.toQueryParams(params)}`,
                null, RequestTypeEnum.FileDownload
                );
        }
    }

}
